{
  "LABEL_MGMT": {
    "HEADER": "תוויות",
    "HEADER_BTN_TXT": "הוסף תווית",
    "LOADING": "מביא תוויות",
    "DESCRIPTION": "תוויות עוזרות לך לסווג ולתעדף שיחות ולידים. תוכל להקצות תווית לשיחה או לאיש קשר באמצעות החלונית הצדדית.",
    "LEARN_MORE": "למד עוד על תוויות",
    "COUNT": "{n} label | {n} labels",
    "SEARCH_PLACEHOLDER": "חפש תוויות...",
    "NO_RESULTS": "No labels found matching your search",
    "SEARCH_404": "אין פריטים התואמים לשאילתה זו",
    "LIST": {
      "404": "אין תוויות זמינות בחשבון זה.",
      "TITLE": "נהל תוויות",
      "DESC": "תוויות מאפשרות לך לקבץ את השיחות יחד.",
      "TABLE_HEADER": {
        "NAME": "שם",
        "DESCRIPTION": "תיאור",
        "COLOR": "צֶבַע",
        "ACTION": "פעולות"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "שם התווית",
        "PLACEHOLDER": "שם התווית",
        "REQUIRED_ERROR": "נדרש שם תווית",
        "MINIMUM_LENGTH_ERROR": "נדרש אורך מינימלי 2",
        "VALID_ERROR": "רק אלפבית, מספרים, מקף וקו תחתון מותרים"
      },
      "DESCRIPTION": {
        "LABEL": "תיאור",
        "PLACEHOLDER": "תיאור תווית"
      },
      "COLOR": {
        "LABEL": "צבע"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "הצג תווית בסרגל הצד"
      },
      "EDIT": "ערוך",
      "CREATE": "צור",
      "DELETE": "מחק",
      "CANCEL": "ביטול"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "הוסף תווית לשיחה",
        "MULTIPLE_SUGGESTION": "בחר תווית זו",
        "DESELECT": "בטל בחירת תווית",
        "DISMISS": "בטל הצעה"
      },
      "POWERED_BY": "Chatwoot AI",
      "DISMISS": "סגור",
      "ADD_SELECTED_LABELS": "הוסף תוויות שנבחרו",
      "ADD_SELECTED_LABEL": "הוסף תווית שנבחרה",
      "ADD_ALL_LABELS": "הוסף את כל התוויות",
      "SUGGESTED_LABELS": "תוויות מוצעות"
    },
    "ADD": {
      "TITLE": "הוסף תווית",
      "DESC": "תוויות מאפשרות לך לקבץ את השיחות יחד.",
      "API": {
        "SUCCESS_MESSAGE": "תווית נוספה בהצלחה",
        "ERROR_MESSAGE": "היתה שגיאה, בקשה נסה שוב"
      }
    },
    "EDIT": {
      "TITLE": "ערוך תווית",
      "API": {
        "SUCCESS_MESSAGE": "התווית עודכנה בהצלחה",
        "ERROR_MESSAGE": "היתה שגיאה, בקשה נסה שוב"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "מחק",
      "API": {
        "SUCCESS_MESSAGE": "התווית נמחקה בהצלחה",
        "ERROR_MESSAGE": "היתה שגיאה, בקשה נסה שוב"
      },
      "CONFIRM": {
        "TITLE": "אשר מחיקה",
        "MESSAGE": "האם אתה בטוח שברצונך למחוק ",
        "YES": "כן, מחק ",
        "NO": "לא, השאר "
      }
    }
  }
}
